"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleLogout = void 0;
const BROADCAST_CHANNEL = 'moment-auth';
/**
 * Signs the user out of Cognito and clears local session state.
 * Also broadcasts a logout event so sibling apps on other subdomains
 * can sign out their own sessions via BroadcastChannel.
 */
const handleLogout = (auth) => {
    const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID ?? '';
    const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN ?? '';
    const logoutUri = window.location.origin;
    try {
        const bc = new BroadcastChannel(BROADCAST_CHANNEL);
        bc.postMessage({ type: 'logout' });
        bc.close();
    }
    catch {
        // BroadcastChannel not supported — proceed without cross-tab signalling
    }
    const redirectToLogout = () => {
        window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
    };
    auth
        .signoutSilent()
        .then(redirectToLogout)
        .catch(redirectToLogout);
};
exports.handleLogout = handleLogout;
